module.exports = __webpack_public_path__ + "f789c296371c61cf28d71def7fbe5b69.pdf";